(function(){
    angular
        .module('appback')
        .factory('socket', socketFact);

        socketFact.$inject = ['$rootScope'];
        function socketFact($rootScope){
        	if(typeof(io)!='undefined'){
		    	//var socket = io.connect("http://192.168.1.34:3000",{transports : ['websocket'],'flash policy port':3000}); 
		    	socket = io.connect("https://ulab.uranovet.com:3000",{ /*transports : ['websocket'],*/ 'flash policy port':3000, /*secure: true*/}); 
	            return {
	            removeAllListeners: function (eventName, callback) {
				  socket.removeAllListeners();
				},
				removeListener: function(name, fn) {
				    socket.removeListener(name, fn);
				},
		        on: function(eventName, callback) {
		            socket.on(eventName, function() {
		                var args = arguments;
		                $rootScope.$apply(function() {
		                    callback.apply(socket, args);
		                });
		            });
		        },
		        emit: function(eventName, data, callback) {
		            socket.emit(eventName, data, function() {
		                var args = arguments;
		                $rootScope.$apply(function() {
		                    if (callback) {
		                        callback.apply(socket, args);
		                    }
		                });
		            })
		        }
		      }
	      }else{
	      	return {
	      		on:function(eventName,callback){
	      			return false;
	      		},
	      		emit:function(eventName,callback){
	      			return false;
	      		}
	      	};
	      }
	    }
})();